// src/components/ForceLogout.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';

function ForceLogout() {
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState(null);
  
  // Mobile-optimized button style
  const mobileButtonStyle = {
    fontSize: '16px',
    fontWeight: '600',
    height: '56px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    border: 'none',
    padding: '0 20px',
    margin: '0 5px',
    appearance: 'none',
    cursor: 'pointer',
    backgroundColor: '#2563eb',
    color: 'white'
  };
  
  useEffect(() => {
    const performForceLogout = async () => {
      try {
        // Get firebase API key from config
        // This is a safe approach that doesn't hardcode the key
        const apiKey = auth.app.options.apiKey;
        
        // Clear any stored auth state
        localStorage.removeItem(`firebase:authUser:${apiKey}:[DEFAULT]`);
        sessionStorage.removeItem(`firebase:authUser:${apiKey}:[DEFAULT]`);
        
        // Sign out from Firebase
        await signOut(auth);
        
        // Update status
        setStatus('success');
      } catch (error) {
        console.error("Error during force logout:", error);
        setError(error.message);
        setStatus('error');
      }
    };
    
    performForceLogout();
  }, []);
  
  return (
    <div className="container mx-auto px-4 py-8 text-center">
      <h1 className="text-2xl font-bold mb-6">Account Reset</h1>
      
      {status === 'processing' && (
        <div className="bg-blue-100 p-6 rounded-lg mb-6">
          <p className="mb-4">Resetting authentication state...</p>
          <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
        </div>
      )}
      
      {status === 'success' && (
        <div className="bg-green-100 p-6 rounded-lg mb-6">
          <p className="mb-4">Your account has been successfully logged out. Any authentication issues should now be resolved.</p>
          <p>Please log in again to access your account.</p>
        </div>
      )}
      
      {status === 'error' && (
        <div className="bg-red-100 p-6 rounded-lg mb-6">
          <p className="mb-4">There was an error resetting your authentication:</p>
          <p className="text-red-600 mb-4">{error}</p>
          <p>Please try clearing your browser cache and cookies, then try again.</p>
        </div>
      )}
      
      <div className="mt-6">
        <Link 
          to="/login" 
          style={mobileButtonStyle}
          className="hover:bg-blue-700"
        >
          Go to Login
        </Link>
      </div>
    </div>
  );
}

export default ForceLogout;